export default {
  title: 'Übersicht',
  table_title: 'Reservierungen',
  filters: {
    card_title: 'Filter',
    today: 'Heute',
    upcoming: 'Anstehend',
    past: 'Vergangen',
    all: 'Alle',
    all_dates: 'Gesamt',
    pending: 'Bestätigung ausstehend',
    canceled: 'Storniert',
    removed: 'Entfernt',
    date_label: 'Datum:',
    status_label: 'Status:',
    source_label: 'Quelle:',
    source_website: 'Website',
    source_google: 'Google',
    search_label: 'Suche:',
    search_placeholder: 'Nach Vor- oder Nachname suchen',
    custom_date_tooltip: 'Bestimmtes Datum wählen',
    active_label: 'Aktive Filter:',
    clear_all: 'Alle zurücksetzen',
  },
  tooltips: {
    total_reservations: 'Reservierungen gesamt',
    total_guests: 'Gäste gesamt',
    refresh: 'Aktualisieren',
  },
  empty: {
    default: 'Noch keine Reservierungen.',
    filtered: 'Keine Reservierungen passen zu deinen Filtern.',
  },
  fields: {
    company: 'Restaurant',
    datetime: 'Datum / Uhrzeit',
    customer: 'Kunde',
    source: 'Quelle',
    guests: 'Gäste',
    status: 'Status',
    created_at: 'Erstellt am',
  },
  status: {
    confirmed: 'Bestätigt',
    pending: 'Warte auf Bestätigung',
    canceled: 'Storniert',
    rejected: 'Abgelehnt',
    removed: 'Entfernt',
  },
  buttons: {
    details: 'Details',
    add_reservation: 'Reservierung hinzufügen',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
};
